import { useRef, useState } from 'react';

const useVoiceRecorder = (t) => {
  const [isRecording, setIsRecording] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);
  const [audioBlob, setAudioBlob] = useState(null);
  const mediaRecorderRef = useRef(null);
  const recordingTimerRef = useRef(null);
  // MediaRecorder.onstop fires asynchronously AFTER cancelRecording ran, so a
  // plain setAudioBlob(null) in cancel would be overwritten by the late blob.
  const discardRef = useRef(false);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      const audioChunks = [];
      discardRef.current = false;

      mediaRecorder.ondataavailable = (event) => {
        audioChunks.push(event.data);
      };

      mediaRecorder.onstop = () => {
        if (!discardRef.current) {
          const blob = new Blob(audioChunks, { type: 'audio/webm' });
          setAudioBlob(blob);
        }
        discardRef.current = false;
        stream.getTracks().forEach((track) => track.stop());
      };

      mediaRecorder.start();
      mediaRecorderRef.current = mediaRecorder;
      setIsRecording(true);
      setRecordingTime(0);

      recordingTimerRef.current = setInterval(() => {
        setRecordingTime((prev) => prev + 1);
      }, 1000);
    } catch (err) {
      console.error('Microphone access denied:', err);
      alert(t.microphoneAccess);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      clearInterval(recordingTimerRef.current);
    }
  };

  const cancelRecording = () => {
    if (isRecording) {
      discardRef.current = true;
      stopRecording();
    }
    setAudioBlob(null);
    setRecordingTime(0);
  };

  return {
    isRecording,
    recordingTime,
    audioBlob,
    startRecording,
    stopRecording,
    cancelRecording,
    setAudioBlob,
    mediaRecorderRef,
    recordingTimerRef,
  };
};

export default useVoiceRecorder;
